export default __webpack_public_path__ + "static/media/INTER-SCHOOL COMPETITIONS flyer.8bc2801a.pdf";